
import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        role: '='
    },
    template: `
        <h1>{{ 'user.Add role' | translate }}</h1>
        <user-group-form-role form="vm.form" role="vm.role"/>
`
})
export default class {
    constructor (FormFactory) {
        this.form = FormFactory.create(this.role, model => model.$save());
    }
}




// WEBPACK FOOTER //
// ./src/app/components/user/group/add/role/index.js